// import axios from 'axios'
import { post, put, get } from '@/api/api'

export const actions = {
  fetchAgregateurs ({ commit}) {
    // const { pageNumber = 0, pageSize = state.pagination.size } = params
    return get(`/canal/agregateur`)
      .then(({ data }) => {
        commit('addAgregateurs', data)
      })
  },
  async fetchAgregateurPage({commit}, params = {}) {
    const { pageNumber = 0, pageSize = 10, sort = '', code = '', libelle = '', after = '', before = '' } = params;
    const queryParams = new URLSearchParams({
      pageNumber,
      pageSize,
      sort, 
      ...(code && { code }),
      ...(libelle && { libelle }),
      ...(after && { after }),
      ...(before && { before }),
    }).toString();

    let { data } = await get(`/canal/agregateur/page?${queryParams}`);
    commit("addAgregateurPage", data)
    return data;
  },
  createAgregateur ({ commit }, agregateur) {
    return post('/canal/agregateur', agregateur)
      .then(({ data }) => {
        commit('addAgregateur', data)
      })
  },
  updateAgregateur ({ commit }, agregateur) {
    return put(`/canal/agregateur/${agregateur.id}`, agregateur)
      .then(({ data }) => {
        commit('replaceAgregateur', data)
      })
  },
  createOrUpdateAgregateur ({ dispatch }, agregateur) {
    if (agregateur.id !== undefined) {
      return dispatch('updateAgregateur', agregateur)
    } else {
      return dispatch('createAgregateur', agregateur)
    }
  },
  selectAgregateur ({ commit }, agregateur) {
    commit('setAgregateur', agregateur)
  },
  deleteAgregateur ({ commit}, agregateur) {
    return remove(`/canal/agregateur/${agregateur.id}`)
      .then(({ data }) => {})
  },
}
